<template>
  <div>
    <!-- <van-button @click="visible = true">點擊輸入</van-button> -->
    <van-popup v-model="visible" :style="{ height: '360px', width: '360px' }">
      <div class="main">
        <van-nav-bar title="密碼輸入" fixed placeholder />
        <!-- {{ value }} -->
        <!-- 密码输入框 -->
        <van-password-input
          :value="value"
          :length="4"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <!-- 数字键盘 -->
        <van-number-keyboard v-model="value" :show="showKeyboard" />
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
.van-popup,
.main {
  width: 360px;
  line-height: 2rem;
}
.van-field {
  margin-top: 1rem;
}
.container {
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tip {
  position: fixed;
  left: 50%;
  bottom: 0rem;
  transform: translate(-50%, -50%);
}
.van-image {
  padding: 0;
  margin: 0;
}
</style>
<script>
export default {
  data() {
    return {
      visible: false,
      // anime: true,
      // phone: "",
      // showKB: false,
      value: "",
      showKeyboard: true,
    };
  },
  watch: {
    value(pValue) {
      if (pValue.length === 4)
        if (pValue !== "1111") {
          this.gMsgbox("密碼錯誤");
          this.value = "";
        } else {
          this.gSure("程式關閉")
            .then(() => {
              // window.close();
              window.opener = null;
              window.open("about:blank", "_self").close();
            })
            .catch(() => {
              this.value = "";
            });
        }
    },
  },
  mounted() {},
  methods: {
    async show() {
      this.value = "";
      this.visible = true;
    },
  },
};
</script>
